/// <reference path="../../auth_form_default/js/gmr.d.ts" />
/// <reference path="../../auth_form_default/js/IFormState.d.ts" />
/// <reference path="IFormOptions.d.ts" />
declare var $;
import DefaultForm from '../../../blocks/auth_form_default/js/DefaultForm';
import sendGtmEvent from '../../../blocks/helpers/sendGtmEvent';

export default class AuthForm extends DefaultForm {
    form_id = 'authForm';
    gmr: GMR;
    options: IFormOptions;
    css_uri = 'https://sf.cdn.gmru.net/static/sf.mail.ru/blocks/auth_form/css/main.css';

    constructor() {
        super();
        this.options = {};
        this.state = {
            rendered: false,
            visible: false
        };
    }


    public init(options: IFormOptions) {
        this.parseOptions(options);
        if (this.options.load_css) {
            this.loadCss(this.css_uri);
        }
        this.renderForm();
    }
    public showForm() {
        sendGtmEvent("ch.registration.init");
        super.showForm();
    }

    private parseOptions(options: IFormOptions) {
        if (!options.gmr) {
            throw new Error('GMR is not defined');
        }
        this.gmr = options.gmr;
        this.options = options;
    }


    private renderForm() {
        var html = this.getHtmlTemplate();
        $('body').append(html);
        this.$form = $('#' + this.form_id);
        this.state.rendered = true;
        this.initEvents();
        if (this.options.visible) {
            this.showForm();
        } else {
            this.hideForm();
        }
    }

    private initEvents() {
        var that = this;
        if (!this.$form) {
            throw new Error('Form is not rendered');
        }
        $('.js-button--mail', this.$form).on('click', function () {
            that.gmr.showSigninForm();
            return false;
        });

        $('.js-button--create-mail', this.$form).on('click', function () {
            that.gmr.showSignupForm();
            return false;
        });

        $('.js-button--vk ', this.$form).on('click', function () {
            that.gmr.showVKSigninForm();
            return false;
        });

        $('.js-button--ok', this.$form).on('click', function () {
            that.gmr.showOKSigninForm();
            return false;
        });

        $('.js-button--close', this.$form).on('click', function () {
            that.hideForm();
            return false;
        });

    }

    private getHtmlTemplate() {
        var id = this.form_id;
        var html = `
        <div class="popup-wrapper" id="${id}">
            <div class="user-auth-form">
                <div class="user-auth-form__logo"></div>
                <h3 class="user-auth-form__header">Регистрация</h3>
                <div class="user-auth-form__close-button js-button--close"></div>
                <div class="user-auth-form__columns">
                     <div class="user-auth-form__column">
                        <div class="user-auth-form__column-title"><span>Через почту Mail.ru</span></div>
                        <div class="user-auth-form__button user-auth-form__button--mail js-button--mail">Войти через<br/> почту Mail.ru</div>
                        <div class="user-auth-form__button user-auth-form__button--create-mail js-button--create-mail">Создать аккаунт Mail.ru</div>
                    </div>
                    <div class="user-auth-form__column  user-auth-form__column--2">
                        <div class="user-auth-form__column-title"><span>Через социальные сети</span></div>
                        <div class="user-auth-form__button user-auth-form__button--vk js-button--vk">Войти через ВКонтакте</div>
                        <div class="user-auth-form__button user-auth-form__button--ok js-button--ok">Войти через Одноклассники</div>
                    </div>
                </div>
                <p class="user-auth-form__rules-text">Регистрируясь, я принимаю условия
                <a href="https://documentation.my.games/gameterms/skyforge_license_agreement" target="_blank">Лицензионного соглашения</a>,<br/>
                <a href="https://documentation.my.games/gameterms/skyforge_game_rules" target="_blank">Правил игры</a>,
                 <a href="https://documentation.my.games/gameterms/skyforge_forum_rules" target="_blank">Правил Форума</a> и
                  <a href="https://documentation.my.games/gameterms/skyforge_privacy" target="_blank">Политики конфиденциальности</a>
                .</p>
            </div>
        </div>`;
        return html.replace(/\s\s*$/gm, "");
    }

}
